<template>
    <div class="table-action-buttons">
        <i v-if="hasPermissionTo('update')"
           @click="edit"
           :title="uLang('app.edit_type', { type: lang('app.application_activity') })"
           class="fa fa-edit fa-lg pointer"
        />
        <i v-if="hasPermissionTo('delete')"
           @click="remove"
           :title="uLang('app.delete_type', { type: lang('app.application_activity') })"
           class="fa fa-trash fa-lg pointer"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { DestroyAlert, ErrorAlert, SuccessAlert } from '~/Swals'

    export default {
        name: 'Actions',
        props: ['data', 'index'],
        computed: {
            ...mapGetters(['authUser']),
        },
        methods: {
            remove() {
                new DestroyAlert({ entity: this.lang('app.application_activity') })
                    .show()
                    .then(async () => {
                        this.destroy()
                    });
            },
            edit() {
                this.$router.push({
                    name: 'admin.relations.application-activities.edit', params: {
                        id: this.data.id,
                        relationId: this.data.relation_id,
                    }
                })
            },
            async destroy() {
                window.axios.delete(route('application-activities.destroy', {
                    application_activity: this.data.id,
                }))
                    .then(({ data }) => {
                        new SuccessAlert({
                            title: uLang('app.application_activity'),
                            text: this.uLang('app.entity_removed', { entity: this.lang('app.application_activity') })
                        }).show();

                        vue.$emit('reloadTable');
                    })
                    .catch(({ response: { data } }) => {
                        new ErrorAlert({
                            title: uLang('app.application_activity'),
                            text: data.message
                        }).show()
                    });
            },
            hasPermissionTo(action) {
                return $hasRole('super_admin') || this.data.relation_id === this.authUser.id || $can(`${ action }-application-activities`);
            }
        },
    }
</script>

<style lang="scss" scoped>
</style>
